// extracted by mini-css-extract-plugin
export default {"notes":"mP93o","notesLabel":"LhvJk"};